module.exports = "/_next/static/images/78dd554508cd61dc83f3f1b72b0df1ec-open-graph-mgm-large.jpg";